import { Mic, MicOff, Video, VideoOff, MonitorUp } from "lucide-react";
import { Type } from "@themes/pollinator/ui/Type";
import Avatar from "@themes/pollinator/ui/Avatar";
import type { RoomMember } from "@core/features/videoMeeting";

export type Props = {
  muted: boolean;
  videoEnabled: boolean;
  sharingContent: boolean;
  attendeeName: string;
  roomMemberData?: RoomMember | null;
};

export function VideoMeetingRosterItem({
  muted,
  videoEnabled,
  sharingContent,
  attendeeName,
  roomMemberData,
}: Props) {
  const role = roomMemberData ? roomMemberData.role : undefined;

  const iconSize = 24;

  return (
    <div
      className="flex flex-row items-center gap-3 justify-between"
      data-testid="roster-cell"
    >
      {roomMemberData && (
        <Avatar
          size={32}
          image={roomMemberData.profile_photo || undefined}
          alt={`${roomMemberData.first_name} ${roomMemberData.last_name}`}
        />
      )}
      <div className="flex flex-col flex-1">
        <div className="flex flex-row items-center gap-2">
          <Type variant="h6">{attendeeName}</Type>
          {roomMemberData?.pronouns && (
            <Type variant="caption" className="text-brand-700">
              ({roomMemberData.pronouns})
            </Type>
          )}
        </div>
        <div className="flex flex-row items-center gap-2">
          {role && (
            <Type variant="caption" className="text-brand-700">
              {role}
            </Type>
          )}
        </div>
      </div>
      <div className="flex flex-row items-center gap-2">
        {muted ? (
          <MicOff size={iconSize} className="stroke-brand-400" />
        ) : (
          <Mic size={iconSize} />
        )}
        {sharingContent ? (
          <MonitorUp size={iconSize} />
        ) : videoEnabled ? (
          <Video size={iconSize} />
        ) : (
          <VideoOff size={iconSize} className="stroke-brand-400" />
        )}
      </div>
    </div>
  );
}

export default VideoMeetingRosterItem;
